import { render, staticRenderFns } from "./FactorDescriptionEditModal.vue?vue&type=template&id=13b27468&"
import script from "./FactorDescriptionEditModal.vue?vue&type=script&lang=js&"
export * from "./FactorDescriptionEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports